<template>
    <BaseDialog
        title="New Author"
        v-model:visible="visible"
        :size="DialogSize.customSize('45rem')"
        :save-action="createAuthor"
        okLabel="Save"
    >
        <template v-slot:content>
            <form @submit.prevent="submitForm" class="grid grid-cols-2 w-full gap-4">
                <FormItem
                    itemLabel="First Name"
                    :isInvalid="v$.firstName.$error"
                    :errorMessage="v$.firstName.required.$message"
                >
                    >
                    <template v-slot:content>
                        <InputText name="firstName" v-model="form.firstName" class="w-full" autocomplete="off" />
                    </template>
                </FormItem>

                <FormItem
                    itemLabel="Last Name"
                    :isInvalid="v$.lastName.$error"
                    :errorMessage="v$.lastName.required.$message"
                >
                    <template v-slot:content>
                        <InputText name="lastName" v-model="form.lastName" class="w-full" autocomplete="off" />
                    </template>
                </FormItem>

                <FormItem itemLabel="Email">
                    <template v-slot:content>
                        <InputText name="email" v-model="form.email" class="w-full" autocomplete="off" />
                    </template>
                </FormItem>

                <FormItem itemLabel="Gender">
                    <template v-slot:content>
                        <Select
                            v-model="form.gender"
                            :options="Genders.getAllOptions()"
                            optionLabel="label"
                            placeholder="Select a gender "
                            class="w-full"
                            style="--p-select-placeholder-color: transparent"
                        ></Select>
                    </template>
                </FormItem>

                <FormItem itemLabel="Race">
                    <template v-slot:content>
                        <Select
                            v-model="form.race"
                            :options="Races.getAllOptions()"
                            optionLabel="label"
                            placeholder="Select a gender "
                            class="w-full"
                            style="--p-select-placeholder-color: transparent"
                        ></Select>
                    </template>
                </FormItem>

                <FormItem itemLabel="Company">
                    <template v-slot:content>
                        <InputText name="company" v-model="form.company" class="w-full" autocomplete="off" />
                    </template>
                </FormItem>

                <FormItem itemLabel="Country">
                    <template v-slot:content>
                        <CountryDropdown
                            v-model:type="LocalizableType.country"
                            @selectedValue="onSelectedCountry"
                        ></CountryDropdown>
                    </template>
                </FormItem>

                <FormItem itemLabel="City">
                    <template v-slot:content>
                        <InputText name="city" v-model="form.city" class="w-full" autocomplete="off" />
                    </template>
                </FormItem>
            </form>
        </template>
    </BaseDialog>
</template>

<script setup>
import BaseDialog from "@/shared/components/BaseDialog.vue";
import FormItem from "@/shared/components/FormItem.vue";
import { InputText, Select } from "primevue";
import { defineModel, defineEmits, inject, reactive } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, email } from "@vuelidate/validators";
import CountryDropdown from "@/shared/common/LozalizationDropdown.vue";
import { useToast } from "primevue/usetoast";
import { DialogSize } from "@/core/enums/DialogSizeEnum";
import { LocalizableType } from "@/core/enums/LocalizableEnum";
import { Genders } from "@/core/enums/GenderEnum";
import { Races } from "@/core/enums/RaceEnum";

const emit = defineEmits(["authorCreated"]);

const visible = defineModel("visible");

const authorService = inject("authorService");

const toast = useToast();

const form = reactive({
    firstName: "",
    lastName: "",
    email: "",
    gender: null,
    race: null,
    company: "",
    country: null,
    city: "",
});

const rules = {
    firstName: { required: helpers.withMessage("First name is required.", required) },
    lastName: { required: helpers.withMessage("Last name is required.", required) },
};

const v$ = useVuelidate(rules, form);

const createAuthor = async () => {
    try {
        if (await v$.value.$validate()) {
            const response = await authorService.create(form);
            toast.add({ severity: "success", summary: "Testimonial Author Created", life: 3000 });
            emit("update:visible", false);
            emit("authorCreated", response);
        }
    } catch (error) {
        console.log(error);
    }
};

const onSelectedCountry = (country) => {
    form.country = country;
};
</script>

<style scoped></style>
